import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import * as configActions from 'modules/config';

import { ConfigRowOption } from 'components';

class CtConfigRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saveStatus: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    const { formStore, paramKey } = nextProps;
    if (formStore && formStore.fields && formStore.fields[paramKey] && formStore.fields[paramKey].active) {
      this.setState({ saveStatus: 0 });
    }
  }

  componentWillUnmount() {
    this.saveConfig();
  }

  handleDismissSaveResult = data => {
    this.setState({ saveStatus: 0 });
  };

  handleOnChange = (event, value) => {
    let paramType = 0;
    if (this.props.parameterData) {
      let paramInfo = {};
      if (Map.isMap(this.props.parameterData)) {
        paramInfo = this.props.parameterData.toJS();
      }
      paramType = paramInfo.paramType;
    }

    if (paramType > 1) {
      // C1. select, checkbox, switch 등은 onChange 이후에 redux-store 반영이 이루어지므로
      // 이 시점에서 변경된 값을 redux-store 통해 구할 수는 없다.
      // 따라서 store 가 아닌 전달 받은 value 로 업데이트 처리한다.
      this.saveConfig(value);
    }
  };

  handleOnBlur = () => {
    this.saveConfig();
  };

  // enter 입력시 저장
  handleOnKeyUp = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.saveConfig();
    }
  };

  saveConfig = async value => {
    const { ConfigActions, formStore, pristine, invalid, error, warning, parameterData } = this.props;

    if (!invalid) {
      let paramInfo = {};
      if (parameterData && Map.isMap(parameterData)) {
        paramInfo = parameterData.toJS();
      }
      const { serviceConfigNo, configType, parameter, beforeValue } = paramInfo;

      let nowValue = String(formStore.values[parameter]);
      // C1 코멘트 참조
      if (typeof value !== 'undefined') {
        nowValue = value;
      }

      if (beforeValue !== nowValue) {
        try {
          await ConfigActions.updateServiceConfig({ serviceConfigNo, parameter, nowValue, beforeValue });
          this.setState({ saveStatus: 1 });
        } catch (e) {
          console.log(e);
          this.setState({ saveStatus: 2 });
        }
      }
    }
  };

  render() {
    const { handleOnChange, handleOnBlur, handleOnKeyUp, handleDismissSaveResult } = this;
    const {
      formStore,
      invalid,
      error,
      warning,
      parameterData,
      // 해당 config의 설명
      parameterNotice,
      allFormStore
    } = this.props;

    let paramInfo = {};
    if (parameterData && Map.isMap(parameterData)) {
      paramInfo = parameterData.toJS();
    }
    const {
      serviceConfigNo,
      category,
      class: configClass,
      configType,
      defaultValue,
      paramOptions,
      paramType,
      parameter,
      value
    } = paramInfo;

    const smtpDisable = allFormStore && allFormStore['config-mailHost'] && allFormStore['config-mailHost'].values.mailHost.includes('smtp.mudfix');

    return (
      smtpDisable && (parameter === 'mailId' || parameter === 'mailPassword') ?
        <div></div>
        :
        <ConfigRowOption
          configId={serviceConfigNo}
          // 임시 언어 작업
          configTitle={parameterNotice[localStorage.getItem('language')]}
          // configTitle={parameter}
          configParameter={parameter}
          configType={paramType}
          cofigDefaultValue={defaultValue}
          configCurrentValue={value}
          configOption={paramOptions}
          saveStatus={this.state.saveStatus}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleOnKeyUp={handleOnKeyUp}
          handleDismissSaveResult={handleDismissSaveResult}
          formStore={formStore}
          invalid={invalid}
          error={error}
          warning={warning}
        />
    );
  }
}

const mapStateToProps = (state, { category, paramKey }) => {
  return {
    // redux-form 기본 설정
    // redux-form 이름을 동적으로 생성할 경우에는 이와 같이 상위 connect 레벨에서 지정해준다.
    // 설정 별로 redux-form 을 구분하는 이유는 현재의 field-level validation 의 경우
    // validation 결과를 Field render component 안에서만 표현이 가능하므로
    // 이것을 바깥으로 빼 좀 더 융통성 있는 화면을 구성하기 위함이다.
    // field-level validation 의 경우 invalid 값만 정상 동작하며,
    // error, warning 값은 정의되지 않아 여기서는 무의미하나 (차후) form 레벨 validation 에서는 이용 가능하다.
    form: 'config-' + paramKey,
    // redux-form 의 경우 신규 입력 양식이 기본이며 기존 데이터의 수정 양식은 이와 같이 초기값을 주고 enableReinitialize 해야한다.
    initialValues: {
      [paramKey]:
        state.config.getIn([category, 'parameter', paramKey, 'value']) ||
        state.config.getIn([category, 'parameter', paramKey, 'defaultValue'])
    },
    // redux-form store 데이터
    formStore: state.form['config-' + paramKey],
    allFormStore: state.form,
    // 각 설정 정보
    parameterData: state.config.getIn([category, 'parameter', paramKey]) //paramInfo
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    enableReinitialize: true
  })(CtConfigRow)
);



// WEBPACK FOOTER //
// ./src/script/containers/config/CtConfigRow.js